import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';

import type { ActionDialogProps } from './types';

export default function ActionDialog({
  open,
  title,
  content,
  secondaryLabel = 'No - Continue Editing',
  primaryLabel,
  onClose,
  onConfirm,
}: ActionDialogProps) {
  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
      <Stack spacing={2}>
        <DialogTitle sx={{ pb: 2 }}>{title}</DialogTitle>
        <DialogContent sx={{ typography: 'body2', pt: 6, fontWeight: 600 }}>
          {content}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3, flexDirection: { xs: 'column', sm: 'row' }, gap: 1.5 }}>
          <Button
            type="button"
            fullWidth
            variant="outlined"
            color="primary"
            onClick={onClose}
            sx={{ whiteSpace: 'normal', textAlign: 'center' }}
          >
            {secondaryLabel}
          </Button>
          <Button
            type="button"
            fullWidth
            variant="contained"
            color="primary"
            onClick={onConfirm}
            sx={{ whiteSpace: 'normal', textAlign: 'center' }}
          >
            {primaryLabel}
          </Button>
        </DialogActions>
      </Stack>
    </Dialog>
  );
}
